import Player from "./components/Player";
import SearchForm from "./components/SearchForm";
import PlayerUI from "./components/PlayerUI";
import "./App.css";
import {useAudio} from './components/context/audio';

function App() {

  const {audio} = useAudio();

  return (
    <div className="app">
      <SearchForm/>

      <PlayerUI/>

      {audio.id.length !== 0 && (
        <Player/>
      )}
    </div>
  );
}

export default App;
